import TemplatePricing from './TemplatePricing'

export default TemplatePricing
